import { object, bool, string } from 'yup'

import {
  PRODUCTIVITY_FIELD,
  SICKNESS_ABSENCE_FIELD,
  TURNOVER_FIELD,
  NO_PRIORITY_FIELD,
} from './model'

export const getSchema = () =>
  object().shape({
    [NO_PRIORITY_FIELD]: bool() | string(),
    [SICKNESS_ABSENCE_FIELD]: bool() | string(),
    [PRODUCTIVITY_FIELD]: bool() | string(),
    [TURNOVER_FIELD]: bool() | string(),
  })
